import { useEffect, useState } from 'react';

/** ارتفاع پیش‌فرض هدر اپ (px) — با style.height در Header.jsx هم‌خوان است */
export const PANEL_STICKY_HEADER_DEFAULT = 56;

/**
 * فاصلهٔ sticky هدر جدول از بالای viewport هنگام اسکرول صفحه.
 * فقط نوار چسبان فعلی (هدر اپ) را اندازه می‌گیرد تا بنرهای اسکرول‌شده
 * آفست را بزرگ نکنند و سطر عنوان روی ردیف‌ها نیفتد.
 */
export function usePanelStickyOffset(defaultOffset = PANEL_STICKY_HEADER_DEFAULT) {
  const [offset, setOffset] = useState(defaultOffset);

  useEffect(() => {
    const measure = () => {
      const header = document.querySelector('.app-shell .app-header') || document.querySelector('.app-header');
      if (!header) {
        setOffset(defaultOffset);
        return;
      }

      setOffset(Math.max(0, Math.ceil(header.getBoundingClientRect().bottom)));
    };

    measure();

    const header = document.querySelector('.app-header');
    const observer = typeof ResizeObserver !== 'undefined' ? new ResizeObserver(measure) : null;
    if (observer && header) {
      observer.observe(header);
    }

    window.addEventListener('resize', measure, { passive: true });
    window.addEventListener('scroll', measure, { passive: true });

    return () => {
      observer?.disconnect();
      window.removeEventListener('resize', measure);
      window.removeEventListener('scroll', measure);
    };
  }, [defaultOffset]);

  return offset;
}
